import {
    getExportBirthdayList,
} from "./api/holderexport"

import {
    postFindByCondition,
    getHolderById,
    putHolder
} from "./api/holder"


import {
    getExport
} from "./api/export"

import { downloadFile, openFile} from '@/utils/files'

class HolderService {

    getParams(level, salesman , connectionCity, connectionTownship, holderName, itemsPerPage){
        var data={} 
        if (connectionCity == null) connectionCity = '';
        if (connectionTownship == null) connectionTownship = '';
        if (level == '' && salesman == '' && connectionCity =='' && connectionTownship =='' && holderName ==''){
            //是否分頁
            if (itemsPerPage!=null) {
                data = { 
                    query_data:{
                        type: 'all',
                        query_options: [],
                        pagination:{
                            itemsPerPage: itemsPerPage
                        }
                    }
                }
            } else {
                data = { 
                    query_data:{
                        type: 'all',
                        query_options: []
                    }
                }
            }
        } else {
            //是否分頁
            if (itemsPerPage!=null) {
                data = { 
                    query_data:{
                        type: 'query',
                        query_options: [],
                        pagination:{
                            itemsPerPage: itemsPerPage
                        }
                    }
                }
            } else {
                data = { 
                    query_data:{
                        type: 'query',
                        query_options: []
                    }
                }
            }

            if (salesman != '') {
                data.query_data.query_options.push({
                    queryField: 'salesman',
                    queryType: 'like',
                    queryData: salesman + '%'
                });
            }

            if (level != '') {
                data.query_data.query_options.push({
                    queryField: 'level',
                    queryType: '=',
                    queryData: level
                });
            }

            if (connectionCity != '') {
                data.query_data.query_options.push({
                    queryField: 'connection_city',
                    queryType: 'like',
                    queryData: connectionCity + '%'
                });
            }

            if (connectionTownship != '') {
                data.query_data.query_options.push({
                    queryField: 'connection_township',
                    queryType: 'like',
                    queryData: connectionTownship + '%'
                });
            }

            if (holderName !='') {
                data.query_data.query_options.push({
                    queryField: 'name',
                    queryType: 'like',
                    queryData: holderName + '%'
                });
            }
        }
        return data
    }
    
    async findCanSendSMSData(level, salesman , holderName, page, itemsPerPage){
        var data = this.getParams(level, salesman, '', '', holderName, itemsPerPage);
        data.query_data.type = "query"
        data.query_data.query_options.push({
            queryField: 'phone',
            queryType: '<>',
            queryData: ''
        });
        //TODO: Phone like 09%
        return  await postFindByCondition(page, data);
    }

    async findByCondition(level, salesman , connectionCity, connectionTownship, holderName, page, itemsPerPage) {
        var data = this.getParams(level, salesman, connectionCity, connectionTownship, holderName, itemsPerPage);
        return  await postFindByCondition(page, data)
    }

    async get(id) {
        //return http.get(`/holder/${id}`);
        return await getHolderById(id)
    }

    async update(id, data) {
        //return http.put(`/holder/${id}`, data);
        return await putHolder(id, data)
    }

    async exportConnection (type,  level, salesman, connectionCity, connectionTownship, exportColumns){
        /*
        var params = {level: level, salesman: salesman, connection_city: connectionCity, connection_township: connectionTownship} 
        console.log(params)
        try {
            const file = await getExportHostConnection(type, params)
            const fileName = `客戶名單`
            const downloadFiles = {
                pdf: () => openFile(file, fileName, 'pdf'),
                excel: () => downloadFile(file, fileName, 'excel')
            }
            downloadFiles[type]()
            return file

            const file = await getExport('/export/holderdata', type, )
        } catch (err) {
            return err
        }
        */
        try{
            console.log(exportColumns,'exportConnection')
            //conditions=查詢條件；columns=匯出欄位
            const file = await getExport(`/export/holderreport`, type, 
                { level: level
                    , salesman: salesman
                    , connection_city: connectionCity
                    , connection_township: connectionTownship
                    , columns: JSON.stringify(exportColumns)});
            const fileName = `客戶名單`
            const downloadFiles = {
                pdf: () => openFile(file, fileName, 'pdf'),
                excel: () => downloadFile(file, fileName, 'excel')
            }
            downloadFiles[type]()
            return file
        } catch (err) {
            return err
        }
    }

    async exportBirthdayList (type,  level, salesman, connectionCity, connectionTownship, birthMonth){
        //var data = this.getParams(level, salesman, connectionCity, connectionTownship, null);
        var params = {level: level, salesman: salesman, connection_city: connectionCity, connection_township: connectionTownship, birth_month: birthMonth} 
        console.log(params)
        try {
            const file = await getExportBirthdayList(type, params)
            const fileName = `生日名單`
            const downloadFiles = {
                pdf: () => openFile(file, fileName, 'pdf'),
                excel: () => downloadFile(file, fileName, 'excel')
            }
            downloadFiles[type]()
            return file
        } catch (err) {
            return err
        }
    }
}

export default new HolderService();